import { configureStore } from '@reduxjs/toolkit';
import rootReducer from '../Reducers';

const Store = configureStore({
   reducer: rootReducer, // this can be from combineReducers or slices or both
   middleware: getDefaultMiddleware =>
      getDefaultMiddleware({ thunk: true, immutableCheck: false, serializableCheck: false }), // thunk is built-in, this line is optional
   devTools: process.env.NODE_ENV !== 'production', // optional but useful
});

export const getStoreState = store => {
   store = store || Store;
   return store?.getState() || {};
};

export default Store;
